import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { DOMAIN_CARDS } from "../data/sectors";
import { MaskedLine, Reveal, SectionNumber } from "./Reveal";

export const Domains = () => (
    <section
        id="domains"
        data-testid="domains-section"
        className="relative bg-white py-28 md:py-36"
    >
        <div className="mx-auto max-w-[1440px] px-6 md:px-10">
            <SectionNumber n="02" label="What We Do" />
            <div className="mb-16 flex flex-wrap items-end justify-between gap-8">
                <h2 className="font-display max-w-3xl text-5xl font-light leading-[1.06] tracking-tighter text-[#0E1112] sm:text-6xl lg:text-7xl">
                    <MaskedLine>Six solutions.</MaskedLine>
                    <MaskedLine delay={0.15} className="text-[#C8102E]">
                        One integrator.
                    </MaskedLine>
                </h2>
                <Reveal delay={0.2} className="max-w-sm">
                    <p className="text-base leading-relaxed text-[#45543F]">
                        Explore each solution — detailed capabilities, process
                        flows and programmes.
                    </p>
                </Reveal>
            </div>

            <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3">
                {DOMAIN_CARDS.map((d, i) => (
                    <Reveal key={d.slug} delay={i * 0.06} className="h-full">
                        <Link
                            to={`/solutions/${d.slug}`}
                            data-testid={`domain-card-${d.slug}`}
                            className="group flex h-full flex-col rounded-2xl border border-[#DCE5D4] bg-[#F7F9F5] p-8 transition-[border-color,transform,background-color] duration-400 hover:-translate-y-1.5 hover:border-[#598B3B]/50 hover:bg-white"
                        >
                            <div className="flex items-center justify-between">
                                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-[#598B3B]/10 text-[#598B3B] transition-[background-color,color] duration-400 group-hover:bg-[#598B3B] group-hover:text-white">
                                    <d.icon size={22} strokeWidth={1.6} />
                                </span>
                                <ArrowUpRight
                                    size={20}
                                    className="text-[#B9C9AE] transition-[color,transform] duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-[#598B3B]"
                                />
                            </div>
                            <h3 className="font-display mt-7 text-2xl font-medium leading-snug tracking-tight text-[#0E1112]">
                                {d.title}
                            </h3>
                            <p className="mt-3 text-sm leading-relaxed text-[#5C6B57]">
                                {d.desc}
                            </p>
                            <span className="mt-auto pt-6 text-xs font-bold uppercase tracking-[0.22em] text-[#598B3B]">
                                Explore
                            </span>
                        </Link>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
